export default "__VITE_ASSET__BCdT3LM1__"